export enum PatientProfileOptionKinds {
  /** TRUE,FALSEを設定する */
  Boolean = 1,
  /** 初期選択値を設定 */
  InitialValue = 2,
  /** 初期選択値を設定（未選択時は空） */
  InitialValueEmpty = 3,
}
